class Modal {

    constructor() {
        this.cacheDom();
        this.bindEvents();
    }

    cacheDom() {
        this.body = document.body;
        this.modal = document.querySelector('.c-modal');
        this.modalToggle = document.querySelectorAll('.c-modal__toggle');
        this.modalClose = document.querySelector('.c-modal__close');
    }

    bindEvents() {
        if (_.isNull(this.modalToggle) === false) {
            Array.prototype.forEach.call(this.modalToggle, (el, i) => {
                el.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.body.classList.add('u-overflow-hidden');
                    this.modal.classList.add('c-modal--open');
                });
            });
        }

        if (_.isNull(this.modalClose) === false) {
            this.modalClose.addEventListener('click', (e) => {
                e.preventDefault();
                this.body.classList.remove('u-overflow-hidden');
                this.modal.classList.remove('c-modal--open');

                const form = document.querySelector('.wpcf7-form');
                const sendBox = document.querySelector('.c-modal__mailsent');
                const output = document.querySelector('.wpcf7-response-output');

                if (_.isNull(form) === false) {
                    form.reset();
                    form.classList.remove('sent');
                    sendBox.classList.remove('c-modal__mailsent--show');
                    output.innerHTML = '';
                    output.classList.remove('wpcf7-mail-sent-ok');
                }
            });
        }

        document.addEventListener('wpcf7mailsent', (event) => {
            // document.querySelector('.c-model__heading').style.display = 'none';
            document.querySelector('.c-modal__mailsent').classList.add('c-modal__mailsent--show');
        }, false);
    }
}

module.exports = Modal;